import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">常见问答</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">关于91吃瓜的常见问题</p>
        <div className="max-w-[800px] mx-auto">
          <div className="space-y-3 md:space-y-4">
            {faqData.map((faq) => (
              <details key={faq.id} className="bg-background-50 rounded-lg border border-background-200 group">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.q}</h3>
                  <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden">
                    <i className="ri-add-line"></i>
                  </span>
                  <span className="flex-shrink-0 w-5 h-5 hidden group-open:flex items-center justify-center text-foreground-400">
                    <i className="ri-subtract-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}